up.$compiler('.sortable', (element, data) => {

  function onSortEnd(_event, _ui) {
    let positionFields = element.find('.sortable--position-field')
    for (let i = 0; i < positionFields.length; ++i) {
      $(positionFields[i]).val(i + 1)
    }
  }

  element.sortable({
    containment: 'parent',
    placeholder: 'sortable--placeholder',
    stop: onSortEnd,
    tolerance: 'pointer', // Default is buggy
    items: '> .sortable--instance'
  })
})
